// main
import { Helmet } from "react-helmet";

import ContentFormat from "../content/webz/content-format-xx";
import WebbHeader from "../content/webz/webb-header-xx";
import WebbFooterMobile from "../content/webz/webb-footer-mobile";

import WebbDividerMedium from "../content/webx/webb-divider-md";
import WebbDividerSmall from "../content/webx/webb-divider-sm";
import WebbLoaderSmall from "../content/webx/webb-loader-sm";

import NetworkViewCreatorModule from "../content/network/network-view-creator";
import NetworkActionsModule from "../content/network/network-actions";
import NetworkListAssetsModule from "../content/network/network-list-assets";

export default function NetworkViewCreator () {
  
  const metadata = {
    name: 'User Details',
    banner: {link: 'https://img.freepik.com/premium-vector/futuristic-vector-hexagon-wave-dark-cyberspace-abstract-wave-with-dots-line-white-moving-particles-background_744733-97.jpg?w=900'}
  }


  return(

  <>
    <Helmet>
      <title>{metadata.name}{' • '}{process.env.REACT_APP_WEBB_SITE_NAME}{' • '}{process.env.REACT_APP_WEBB_SITE_LINE}</title>
      <link rel="canonical" href={process.env.REACT_APP_WEBB_SITE_LINK} />
    </Helmet>

    <ContentFormat 
      
      name = {metadata.name}
      header = {{ size: 'xtra', show: true, data: 
        <> 
          <WebbHeader data={{name: metadata.name, home: '/', link:'network'}} /> 
        </> 
      }}
      media = {{ size: 'xtra', show: false, data: <></> }}

      content = {{ size: 'xtra', show: true, data: 
      <>
        <div className="">
          <NetworkViewCreatorModule />
        </div>

        <WebbDividerMedium />
        <h2 className='text-normal m-0 mx-3 px-3'>{'User Digital Assets'}</h2>
        <WebbDividerMedium />
        <div className="mx-3">
          <NetworkListAssetsModule />
        </div>

        <WebbDividerSmall />
        <div className=""></div>

        <WebbDividerMedium />
        <WebbDividerMedium />
        <WebbDividerMedium />
        <WebbDividerMedium />
        <WebbDividerMedium />
        <WebbDividerMedium />
      </>
      }}
    
      footer = {{ size: 'fluid', show: true, data: 
      <> 
        <div className="text-center back-color-lite">
          
          <WebbFooterMobile /> 
        </div>
      </> }}
    
    ></ContentFormat>


  </>
  )
}